export const REQUIRED_FILED = 'El campo es requerido';
export const REQUIRED_PASSWORD_MIN_FILED = 'Minimo 8 caracteres';